import {memo, useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'

import {BASE_CLASS} from './config.js'

const CardCarfaxModalContent = ({urlIframeContent}) => {
  const {i18n} = useContext(Context)
  const frameBorder = '0'

  return (
    <div className={`${BASE_CLASS}-modal`}>
      <iframe
        src={urlIframeContent}
        className={`${BASE_CLASS}-iframe`}
        frameBorder={frameBorder}
        title={i18n.t('NAME_CHANGE.TITLE')}
      />
    </div>
  )
}

CardCarfaxModalContent.displayName = 'CardCarfaxModalContent'
CardCarfaxModalContent.propTypes = {
  urlIframeContent: PropTypes.string.isRequired
}

export default memo(CardCarfaxModalContent)
